import { memo } from 'react';
import FAQsSection from '../../components/faqsSection';
import PropTypes from 'prop-types';

const _FaqList = ({ faqSections }) => {
	return (
		<div>
			{faqSections.map(({ relatedFaQs, id, showLink, title }) => {
				return (
					<FAQsSection
						key={id}
						title={title}
						items={relatedFaQs}
						showLink={showLink}
						className="faq-page-section"
					/>
				);
			})}
		</div>
	);
};

_FaqList.propTypes = {
	faqSections: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			name: PropTypes.string,
			relatedFaQs: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string,
					question: PropTypes.string,
					answer: PropTypes.shape({
						raw: PropTypes.string,
					}),
				})
			),
			showLink: PropTypes.bool,
			title: PropTypes.string,
		})
	).isRequired,
	title: PropTypes.string,
};

_FaqList.defaultProps = {
	faqSections: [],
	title: '',
};

const FaqList = memo(_FaqList);

export default FaqList;
